// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPolicyFundIdResponseDto
 */
export interface IPolicyFundIdResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyFundIdResponseDto
     */
    exist_enrollment?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPolicyFundIdResponseDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPolicyFundIdResponseDto
     */
    plan_type?: IPolicyFundIdResponseDtoPlanTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IPolicyFundIdResponseDto
     */
    account_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IPolicyFundIdResponseDtoPlanTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IPolicyFundIdResponseDto interface.
 */
export function instanceOfIPolicyFundIdResponseDto(value: object): value is IPolicyFundIdResponseDto {
    return true;
}

export function IPolicyFundIdResponseDtoFromJSON(json: any): IPolicyFundIdResponseDto {
    return IPolicyFundIdResponseDtoFromJSONTyped(json, false);
}

export function IPolicyFundIdResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPolicyFundIdResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'exist_enrollment': json['exist_enrollment'] == null ? undefined : json['exist_enrollment'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_type': json['plan_type'] == null ? undefined : json['plan_type'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
    };
}

export function IPolicyFundIdResponseDtoToJSON(json: any): IPolicyFundIdResponseDto {
    return IPolicyFundIdResponseDtoToJSONTyped(json, false);
}

export function IPolicyFundIdResponseDtoToJSONTyped(value?: IPolicyFundIdResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exist_enrollment': value['exist_enrollment'],
        'plan_id': value['plan_id'],
        'plan_type': value['plan_type'],
        'account_id': value['account_id'],
    };
}

